import { render, staticRenderFns } from "./NoteNewForm.vue?vue&type=template&id=bf0ec6fe&"
import script from "./NoteNewForm.vue?vue&type=script&lang=ts&"
export * from "./NoteNewForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports